import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".3",
      d: "M10 1a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 14a6 6 0 1 1 0-12 6 6 0 0 1 0 12"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 3a6 6 0 1 0 0 12 6 6 0 0 0 0-12m0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
    }, null, -1)
  ]))]))
}
export default { render: render }